import Utils from '@/ecm/common/Utils'
export default class DistributionItem {
    constructor(dto) {
        this.uuid = Utils.object.getUUID()
        this.autor = ''
        this.isViewed = false
        this.requiresValidation = false
        this.requiresSignature = false
        this.isValidated = false
        this.isRejected = false
        this.isExpired = false
        this.isSigned = false
        this.dueDate = ''

        if (dto) {
            this.autor = dto.UserName
            this.isViewed = dto.IsViewed
            this.requiresValidation = dto.RequiresValidation
            this.requiresSignature = dto.RequiresSignature
            this.isValidated = dto.IsValidated
            this.isRejected = dto.IsRejected
            this.isSigned = dto.IsSigned
            this.dueDate = dto.DisplayDueDate
        }
    }
}
